import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import i18next from 'v2/helpers/i18n';
import BoqRefineDiffCell from './BoqRefineDiffCell';
import {
  refineAcceptIconButtonSx,
  refineRejectIconButtonSx,
  refineRowActionsSx,
} from './refineStyle';

const renderBaseCell = (column, params) => {
  if (column.renderCell) return column.renderCell(params);
  return params?.formattedValue ?? params?.value ?? '';
};

const buildRefineColumns = ({
  baseColumns,
  units = [],
  pendingChanges = {},
  onAcceptRow = () => null,
  onRejectRow = () => null,
}) => {
  const decorated = baseColumns.map((column) => ({
    ...column,
    renderCell: (params) => {
      const fields = pendingChanges?.[String(params?.row?.id)]?.fields;
      const change = fields?.[column.field];
      if (!change) return renderBaseCell(column, params);
      return (
        <BoqRefineDiffCell
          field={column.field}
          before={change.before}
          after={change.after}
          units={units}
        />
      );
    },
  }));

  decorated.push({
    field: 'refine_actions',
    headerName: '',
    width: 76,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    align: 'right',
    renderCell: (params) => {
      const rowId = params?.row?.id;
      if (!pendingChanges?.[String(rowId)]) return null;
      return (
        <Box sx={refineRowActionsSx}>
          <IconButton
            aria-label={i18next.t('boq-refine-review-accept-row')}
            onClick={() => onAcceptRow(rowId)}
            sx={refineAcceptIconButtonSx}
            size="small"
          >
            <CheckIcon fontSize="small" />
          </IconButton>
          <IconButton
            aria-label={i18next.t('boq-refine-review-reject-row')}
            onClick={() => onRejectRow(rowId)}
            sx={refineRejectIconButtonSx}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      );
    },
  });

  return decorated;
};

export default buildRefineColumns;
